import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { CloseButton, Col, Container, Image, Row, Spinner, Tab, Tabs, Table  } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import Category from './Category';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import * as RIcon from "react-icons/fa"
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CardRegist from './common/CardRegist';
import { Alert, Button, Card, CardContent, CardHeader, CardMedia, Chip, Typography, Box, Grid, Paper } from '@mui/material';
import ApiFetch from './ApiFetch';
import CommonDialog from './common/CommonDialog';
import LoadingButton from '@mui/lab/LoadingButton';
import DirectdebitRegist from './common/DirectdebitRegist';
import Constants from './common/Constants';
import { LoginInfo } from '../App';
import SettingPopup from './SettingPopup';

const Payouts = () => {
	async function getRevenueInfo(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payouts/revenue").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getPayoutsHistory(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payment/payouts").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function updatePaymentMethod(id,statusToken){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payment/method",{id:id,statusToken:statusToken}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function updateDefault(id,flag){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payment/default",{id:id,flag:flag}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function deleteCard(id){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payment/card",{id:id}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getBankInfo(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payouts/bank").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getShienInfo(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payouts/shien").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getIDInfo(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/id").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getUpdateInfo(){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payouts/bank").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getDeleteInfo(){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payouts/bank").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const navigate = useNavigate()
    const location = useLocation()
    const [selected,setSelected] = useState(0)
    const [showRegistConfirm,setShowRegistConfirm] = useState(false)
    const [showDeleteConfirm,setShowDeleteConfirm] = useState(false)
    const [showDefaultConfirm,setShowDefaultConfirm] = useState(false)
    const [loadingPaymentStatus,setLoadingPaymentStatus] = useState(false)
    const [loadingPaymentDefault,setLoadingPaymentDefault] = useState(false)
    const [showSetting,setShowSetting] = useState(false)
    const [loading,setLoading] = useState(true)
    const [revenueInfo,setRevenueInfo] = useState([])
    const [payoutsHistory,setPayoutsHistory] = useState([])
    const [bankInfo,setBankInfo] = useState([])
    const [shienInfo,setShienInfo] = useState([])
    const [idInfo,setIDInfo] = useState([])
    let param = location.search
    useEffect(() => {
        document.title = "支援・売上金管理 - アワートAI"
        let id = param.substring(param.indexOf("id?=")+5,param.indexOf("&statusToken="))
        let statusToken = param.substring(param.indexOf("&statusToken=")+13)
        if(id.length === 36 && statusToken.length > 0){
            setLoadingPaymentStatus(true)
            updatePaymentMethod(id,statusToken).then(r => {
                if(r.result){
                    if(r.data.status){
                        setTimeout(() => window.location.href = "/payment?status=OK",1000)
                    } else {
                        window.location.href = "/payment?status=NG"    
                    }
                } else {
                    alert(r.errors)
                }
                setLoadingPaymentStatus(false)
            })
        } else {
            getRevenueInfo().then(r => {
                if(r.result){
                    setRevenueInfo(r.data)
                }
                setLoading(false)
            })
            getPayoutsHistory().then(r => {
                if(r.result){
                    setPayoutsHistory(r.data)
                }
                setLoading(false)
            })
        }
        // 銀行口座
        getBankInfo().then(r => {
            if(r.result){
                setBankInfo(r.data)
            }
        })
        // 支援金額等
        getShienInfo().then(r => {
            if(r.result){
                setShienInfo(r.data)
            }
        })
    },[])

    return(
    <div className="wrapper" style={{backgroundColor:"#EEEEEE",borderRadius:"10px"}}>
        <header className="App-header"></header>
        {showSetting ? (<SettingPopup switch={setShowSetting} />) : ""}
        <Header />
        <Category />
        <CommonDialog open={showRegistConfirm}
            content={<DirectdebitRegist bank={bankInfo} />}
            onClick={() => setShowRegistConfirm(false)} onClose={() => setShowRegistConfirm(false)} />
        <CommonDialog open={showDeleteConfirm}
            onClick={() => {
                setShowDeleteConfirm(false)
                deleteBank().then(r => {
                    if(r.result){
                        getBankInfo().then(r => {
                            if(r.result){
                                window.location.reload()
                                setBankInfo(r.data)
                            }
                        })
                    }
                })
            }} onClose={() => setShowDeleteConfirm(false)}
            title="振込先口座を削除しますか？" buttonLabel="削除" buttonColor="warning" showCancelbutton={true} />
        <Container className='w-100' style={{padding: '20px'}}>
            <Typography variant="h4" component="h1" gutterBottom sx={{marginBottom: 3, fontWeight: 'bold'}}>
                支援・売上金管理
            </Typography>
            
            {/* 残高カード */}
            <Card sx={{marginBottom: 3, borderRadius: 2, boxShadow: 2}}>
                <CardContent sx={{padding: 3}}>
                    <Typography variant="h6" color="text.secondary" gutterBottom>
                        残高
                    </Typography>
                    {revenueInfo.list === undefined ? (
                        <Box display="flex" alignItems="center" sx={{height: 60}}>
                            <Spinner size='sm' />
                        </Box>
                    ) : (
                        <Typography variant="h3" component="div" sx={{fontWeight: 'bold', marginBottom: 2}}>
                            {Constants.CURRENCY_UNIT_LEFT}{(revenueInfo.total || 0).toLocaleString()}
                        </Typography>
                    )}
                    <Typography variant="body2" color="text.secondary" sx={{marginBottom: 3}}>
                        残高が5,000円以上ある場合、支援金は翌月のいずれかの日に1回振り込まれます。
                    </Typography>
                    
                    {/* アクションボタン */}
                    <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 2, marginBottom: 2}}>
                        <Button 
                            variant="outlined" 
                            onClick={() => setShowRegistConfirm(true)}
                            startIcon={loading ? null : bankInfo.bank_name !== undefined ? 
                                <Icon.CheckCircle style={{color:"green"}} /> : 
                                <Icon.ExclamationCircle style={{color:"red"}} />}
                        >
                            振込先口座設定
                        </Button>
                        <Link to={"/manage/id"} style={{textDecoration: 'none'}}>
                            <Button 
                                variant="outlined"
                                startIcon={loading ? null : loginInfo.id_auth === 1 ? 
                                    <Icon.CheckCircle style={{color:"green"}} /> : 
                                    <Icon.ExclamationCircle style={{color:"red"}} />}
                            >
                                本人確認
                            </Button>
                        </Link>
                        <Button 
                            variant="outlined" 
                            onClick={() => setShowSetting(true)}
                            startIcon={loading ? null : loginInfo.sms_auth === 1 ? 
                                <Icon.CheckCircle style={{color:"green"}} /> : 
                                <Icon.ExclamationCircle style={{color:"red"}} />}
                        >
                            SMS認証
                        </Button>
                    </Box>
                    
                    {/* 収益化案内 */}
                    {!loading && (bankInfo.bank_name === undefined || loginInfo.id_auth === 0 || loginInfo.sms_auth === 0) && (
                        <Alert severity='info' sx={{marginTop: 2}}>
                            <Typography variant="body2" gutterBottom>
                                振込先口座設定と本人確認、SMS認証を済ませて収益化を有効にしましょう。
                            </Typography>
                            <Box sx={{display: 'flex', flexDirection: 'column', gap: 1, marginTop: 2}}>
                                <Button 
                                    onClick={() => setShowRegistConfirm(true)} 
                                    variant='outlined' 
                                    size="small"
                                >
                                    振込先口座を設定する
                                </Button>
                                <Button variant='outlined' size="small" onClick={() => navigate("/manage/id")}>
                                    本人確認する
                                </Button>
                                <Typography variant="caption" sx={{marginTop: 1}}>
                                    SMS認証は「設定画面」→「セキュリティ」タブから行えます。
                                </Typography>
                                <Button 
                                    onClick={() => setShowSetting(true)} 
                                    variant='outlined' 
                                    size="small"
                                >
                                    設定画面を開く
                                </Button>
                            </Box>
                        </Alert>
                    )}
                </CardContent>
            </Card>
            
            {/* 統計情報カード */}
            <Grid container spacing={3} sx={{marginBottom: 3}}>
                <Grid item xs={12} sm={6}>
                    <Card sx={{height: '100%', borderRadius: 2, boxShadow: 2}}>
                        <CardContent sx={{padding: 3, textAlign: 'center'}}>
                            <Typography variant="h6" color="text.secondary" gutterBottom>
                                支援者数
                            </Typography>
                            {revenueInfo.list === undefined ? (
                                <Box display="flex" justifyContent="center" alignItems="center" sx={{height: 60}}>
                                    <Spinner size='sm' />
                                </Box>
                            ) : (
                                <Typography variant="h3" component="div" sx={{fontWeight: 'bold', color: 'primary.main'}}>
                                    {(shienInfo.count || 0).toLocaleString()}
                                </Typography>
                            )}
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Card sx={{height: '100%', borderRadius: 2, boxShadow: 2}}>
                        <CardContent sx={{padding: 3, textAlign: 'center'}}>
                            <Typography variant="h6" color="text.secondary" gutterBottom>
                                支援額
                            </Typography>
                            {revenueInfo.list === undefined ? (
                                <Box display="flex" justifyContent="center" alignItems="center" sx={{height: 60}}>
                                    <Spinner size='sm' />
                                </Box>
                            ) : (
                                <Typography variant="h3" component="div" sx={{fontWeight: 'bold', color: 'success.main'}}>
                                    {Constants.CURRENCY_UNIT_LEFT}{(shienInfo.amount || 0).toLocaleString()}
                                </Typography>
                            )}
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            
            {/* 履歴タブ */}
            <Card sx={{borderRadius: 2, boxShadow: 2}}>
                <Tabs defaultActiveKey={"revenue"} onSelect={() => {}}>
                    <Tab eventKey="revenue" title="支援金履歴">
                        <Box sx={{padding: 3}}>
                            {revenueInfo.list !== undefined && revenueInfo.list.length > 0 ? (
                                <Table striped bordered hover style={{width:"100%"}}>
                                    <thead>
                                        <tr><th>年月</th><th>金額</th></tr>
                                    </thead>
                                    <tbody>
                                        {revenueInfo.list.map((d, index) => (
                                            <tr key={index}>
                                                <td>{d.ym}</td>
                                                <td>{Constants.CURRENCY_UNIT_LEFT}{parseInt(d.amount).toLocaleString()}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <Box sx={{textAlign: 'center', padding: 4}}>
                                    <Typography variant="body1" color="text.secondary">
                                        支援金履歴がありません
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </Tab>
                    <Tab eventKey="payouts" title="振込履歴">
                        <Box sx={{padding: 3}}>
                            {payoutsHistory.list !== undefined && payoutsHistory.list.length > 0 ? (
                                <Table striped bordered hover style={{width:"100%"}}>
                                    <thead>
                                        <tr><th>日時</th><th>金額</th><th>処理状況</th></tr>
                                    </thead>
                                    <tbody>
                                        {payoutsHistory.list.map((d, index) => (
                                            <tr key={index}>
                                                <td>{d.ymdhi}</td>
                                                <td>
                                                    {Constants.CURRENCY_UNIT_LEFT}{d.amount.toLocaleString()}
                                                    <br />
                                                    <span style={{fontSize:"14px",color:"#555555"}}>
                                                        (内振込手数料{Constants.CURRENCY_UNIT_LEFT}{d.fee.toLocaleString()})
                                                    </span>
                                                </td>
                                                <td>{d.status === "1" ? "処理完了" : "処理中"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <Box sx={{textAlign: 'center', padding: 4}}>
                                    <Typography variant="body1" color="text.secondary">
                                        振込履歴がありません
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </Tab>
                </Tabs>
            </Card>
        </Container>
        <Footer />
    </div>
    )
}

export default Payouts;
